// get.ts

import { axios } from '@/api/common'
import { queryOptions } from '@tanstack/react-query'
import { Po1010Model, Po1010Schema } from './get.schema'

export async function fetchPo1010(id: number): Promise<Po1010Model> {
  const response = await axios.get<Po1010Model>(`/api/purchase/po1010/${id}`)
  return Po1010Schema.parse(response.data)
}

export const getPo1010ByIdOptions = (id: number) =>
  queryOptions({
    queryKey: ['po1010', id],
    queryFn: () => fetchPo1010(id),
  })
